import { render, staticRenderFns } from "./vkButton.vue?vue&type=template&id=12067a05&"
import script from "./vkButton.vue?vue&type=script&lang=js&"
export * from "./vkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports